import axios, { AxiosInstance } from 'axios';
import Cookies from 'js-cookie';
const apiClient: AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}/api/stripe`,
  headers: {
    'Content-Type': 'application/json',
  },
});


apiClient.interceptors.request.use(
  (config) => {
    const token = Cookies.get('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


interface priceRequest {
  plantype: string;
  periodTime: string;
}
interface priceResponse {
  sessionId: string;
  url: string;
}
export async function createPortalSession(): Promise<priceResponse> {
  try {
    const response = await apiClient.get<priceResponse>('/create-portal-session');
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Customer not found');
  }
}
export async function checkout(data: priceRequest): Promise<priceResponse> {
  try {
    const response = await apiClient.post<priceResponse>('/checkout', data);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Invalid Price');
  }
}
export async function getSubscription() {
  try {
    const response = await apiClient.get('/subscription');
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'No Subscription to this user');
  }
}
export async function getPriceData(param: priceRequest) {
  try {
    const response = await apiClient.get('/price', { params: param });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'No Subscription to this user');
  }
}